import { Link } from "react-router-dom";

const quickLinks = [
  { label: "影视作品", to: "/works" },
  { label: "最新动态", to: "/news" },
  { label: "个人资料", to: "/profile" },
  { label: "关于本站", to: "/about" },
];

const socials = [
  { icon: "ri-twitter-x-line", label: "X" },
  { icon: "ri-instagram-line", label: "Instagram" },
  { icon: "ri-youtube-line", label: "YouTube" },
  { icon: "ri-weibo-line", label: "微博" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500">
                <i className="ri-movie-2-line text-lg text-background-50"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-bold text-white">奥田咲</span>
                <span className="text-[10px] tracking-[0.28em] text-background-400 mt-1">
                  SAKI OKUDA
                </span>
              </span>
            </div>
            <p className="mt-5 text-sm leading-7 text-background-300 max-w-md">
              本站为奥田咲的个人影视资料展示平台，集中收录其影视作品档案、演职信息与最新动态，方便影迷与内容查询用户快速查阅。所有内容均为演示数据。
            </p>
            <div className="mt-6 flex items-center gap-2.5">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href="https://rajamas.asia"
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.label}
                  className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-white tracking-wide">
              <span>快捷导航</span>
            </h4>
            <ul className="mt-5 space-y-3">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-background-300 hover:text-accent-300 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-white tracking-wide">
              <span>内容说明</span>
            </h4>
            <p className="mt-5 text-sm leading-7 text-background-300">
              本站为影迷向资料整理站点，与艺人本人及其所属机构无任何官方关联。站内作品信息、动态资讯及人物资料均为演示用途，如有出入请以官方发布为准。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 奥田咲影迷门户 · 演示站点 · 保留所有权利
          </p>
          <div className="flex items-center gap-5 text-xs text-background-400">
            <Link to="/about" className="hover:text-accent-300 transition-colors">
              合规声明
            </Link>
            <Link to="/about" className="hover:text-accent-300 transition-colors">
              联系反馈
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}